module.exports = __webpack_public_path__ + "img/Subhranil.7af64103.jpeg";